<template>
  <div :class="[`moto-2`, className || ``]">
    <p class="build-up-the-whole-p inter-extra-bold-link-water-24px">
      <span class="span-1 inter-extra-bold-link-water-24px">kreiraj </span
      ><span class="span-1 inter-semi-bold-link-water-24px">svoje alate. <br /></span
      ><span class="span-1 inter-extra-bold-link-water-24px">integriši </span
      ><span class="span-1 inter-semi-bold-link-water-24px">sve servise.<br /></span
      ><span class="span-1 inter-extra-bold-link-water-24px">automatizuj </span
      ><span class="span-1 inter-semi-bold-link-water-24px">svoje procese.</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "Moto2",
  props: ["className"],
};
</script>

<style>
.moto-2 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  position: relative;
  margin: 0 auto;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  padding: 50px 0px 
}

.build-up-the-whole-p {
  letter-spacing: -0.5px;
  line-height: 40px;
  position: relative;
  text-align: center;
  width: fit-content;
}

.moto-2.moto-2-1 {
  left: 36px;
  top: 4219px;
}
</style>
